import React from 'react';
import { Provider } from 'jotai';
import mixpanel from 'mixpanel-browser';
import Router from './routing/Router';
import './assets/style/App.scss';
import '@blueprintjs/core/lib/css/blueprint.css';

const App: React.FC = () => {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN!, {
    debug: true,
    ignore_dnt: true,
  });

  return (
    <Provider>
      <div className='App'>
        <Router />
      </div>
    </Provider>
  );
};

export default App;
